import React from 'react';
import {
  Heading,
  VStack,
} from '@chakra-ui/react';
import TextAreaField from './form/TextAreaField';
import { required } from './form/validators';

const BusinessDetailsView = (): JSX.Element => {
  return (
    <fieldset>
      <legend>
        <Heading fontSize="2xl" mb={6}>Business Details</Heading>
      </legend>
      <VStack spacing={5}>
        <TextAreaField
          name="description"
          placeholder="Provide a high level description of the business and what they do"
          validate={required('Please enter a description of your business.')}
          h="7lh"
        />
      </VStack>
    </fieldset>
  );
};

export default BusinessDetailsView;
